/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CALENDAR_RECORD_LIMITED_AVAILABILITY_NOTIFICATION_SCHEDULE = gql`
  mutation calendarRecordLimitedAvailabilityNotificationScheduleNoId($records: [ID!]) {
    calendar {
      records(scheduleLimitedAvailabilityNotification: $records) {
        records {
          id
        }

        errors
        validations
      }
    }
  }
`;
